import React from "react"
import Carousel, { Modal, ModalGateway } from "react-images";

const PhotoViewer = ({closeLightbox, currentImage, viewerIsOpen, photos}) => {
    return (
        <ModalGateway>
            {viewerIsOpen ? (
                <Modal onClose={closeLightbox}>
                    <Carousel
                        currentIndex={currentImage}
                        views={photos.map(x => ({
                            ...x,
                            srcset: x.srcSet,
                            caption: x.title
                        }))}
                    />
                </Modal>
            ) : null}
        </ModalGateway>
    )
}

export default PhotoViewer